export default __webpack_public_path__ + "static/media/part_5.b3de46fe.png";